import { checkEnvironment } from '@saviynt/common';

const getListRowApiUrl = (isJitForApps) => {
  const { GATEWAY_API_URL } = checkEnvironment();

  if (isJitForApps) {
    return `${GATEWAY_API_URL}/api/pam/jitauseraccess`;
  }

  return `${GATEWAY_API_URL}/api/pam/useraccess`;
};

export default getListRowApiUrl;
